import { configureStore } from '@reduxjs/toolkit';
import { addressSlice } from '@qbe/dfc-services';
import config from './config';
import { SOURCE_SYSTEM } from './utils/constants';

// Create a single instance of the address API slice
export const addressApiSlice = addressSlice({
  baseUrl: `${config.apimBase}`,
  headers: {
    'X-SourceSystem': SOURCE_SYSTEM,
  },
});

export const { useLazyGetAddressesQuery, useStructuredAddressLookupMutation } = addressApiSlice;

export const store = configureStore({
  reducer: {
    [addressApiSlice.reducerPath]: addressApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(addressApiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
